import { Redirect, Route, Switch } from 'react-router';
import { EditTemplate } from './EditTemplate';
import { TemplateIndex } from './TemplateIndex';

export const TemplateRoutes = () => {
  return (
    <Switch>
      <Route
        path="/settings/templates"
        exact
        render={() => <Redirect to="/settings/templates/recovery" />}
      />
      <Route
        path={['/settings/templates/recovery', '/settings/templates/payment-plans']}
        exact
        component={TemplateIndex}
      />
      {/* The editor used to live at /settings/templates/edit/:id: keep bookmarks working. */}
      <Redirect exact from="/settings/templates/edit/:id" to="/settings/templates/:id" />
      <Route path="/settings/templates/:templateId" component={EditTemplate} />
    </Switch>
  );
};
